import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../core/models/contact-type.model'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../shared/components/table-list/table-list.component'
import { ServiceTypeCreateComponent } from '../../features/service/service-type-create/service-type-create.component'
import { ServiceTypeService } from '../../core/services/service/service-type/service-type.service'
import { ServiceTypeEditComponent } from '../../features/service/service-type-edit/service-type-edit.component'
import { FormSearchComponent } from '../../shared/components/form-search/form-search.component'
import { ServiceOrderService } from '../../core/services/service/service-order/service-order.service'
import { ServiceOrderCreate } from '../../features/service/service-order/service-order-create/service-order-create.component'
import { ContractCreateComponent } from '../../features/contract/contract-create/contract-create.component'
import { ResponseRequestModel } from '../../core/models/response.model'
import { downloadBase64File } from '../../shared/utils/download_base64'
import { convertCurrency } from '../../shared/utils/utils'
import { ProposalClientCreateComponent } from '../../features/proposal/proposal-client-create/proposal-client-create.component'
import { ProposalClientEditComponent } from '../../features/proposal/proposal-client-edit/proposal-client-edit.component'
import { ProposalClientService } from '../../core/services/proposal/proposal-client/proposal-client.service'
import { ContractClientService } from '../../core/services/contract/contract-client/contract-client.service'
import { MatPaginator, PageEvent } from '@angular/material/paginator'
import { DialogChooseComponent } from '../../shared/components/dialog-to-choose/dialog-to-choose.component'
import { SearchContractComponent } from './search-contract/search-contract.component'
import { TableListContractComponent } from '../../shared/components/table-list-contract/table-list-contract.component'
import { ModalCancelContractComponent } from '../../features/contract/modal-cancel-proposal/modal-cancel-contract.component'

@Component({
  selector: 'contract',
  imports: [
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    MatPaginator,
    SearchContractComponent,
    TableListContractComponent,
  ],
  templateUrl: './contract-proposal.component.html',
  styleUrl: './contract-proposal.component.scss',
  providers: [ServiceOrderService, AuthService],
  standalone: true,
})
export class ContractComponent implements OnInit {
  constructor(
    private proposalClientService: ProposalClientService,
    private contractClientService: ContractClientService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {
    this.user = this.authService.getInfosObject()
  }

  user: any = {}
  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''

  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'codeTg',
      key: 'codigoTg',
      description: 'Codigo Tg',
    },
    {
      keyColumn: 'event',
      key: 'nomeEvento',
      description: 'Evento',
    },
    {
      keyColumn: 'contract_period',
      key: 'dataInicio',
      description: 'Período',
    },
    {
      keyColumn: 'contract_client',
      key: 'nomeCliente',
      description: 'Cliente',
    },
    {
      keyColumn: 'contract_consult',
      key: 'nomeConsultorOperacional',
      description: 'Consultor',
    },
    {
      keyColumn: 'status',
      key: 'statusDescricao',
      description: 'Status',
    },
    {
      keyColumn: 'total',
      key: 'valorTotalFormatado',
      description: 'Valor Total',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false, view: true, cancelContract: false },
      description: 'Ações',
    },
  ]
  screen: string = 'contrato cliente'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        // edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
        view: true,
        cancelContract: this.checkPermission('cancelar contrato'),
        // this.user.idPerfil &&
        // (this.user.idPerfil == 1 ||
        //   this.user.idPerfil == 2 ||
        //   this.user.idPerfil == 3)
        //   ? true
        //   : false,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    this.loading = true
    this.contractClientService
      .searchPagedContractClient(this.page, this.rows, event)
      .subscribe({
        next: (res) => {
          this.loading = false
          if (res.data === null) {
            this.numberRows = 0
          } else {
            this.numberRows = res.data.totalItens
          }

          this.treatResponse(res)
        },
        error: (err: any) => {
          console.error('Ocorreu um erro ao listar os motoristas', err)
        },
      })
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      // this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    // console.log('Retorno da API:', response);
    let list = []
    if (response.data) {
      for (let item of response.data) {
        // Verifica se o status da proposta é 'Pendente'

        list.push({
          ...item,
          valorTotalFormatado: `R$ ${convertCurrency(item.valorTotal)}`,
        })

        // if (item.statusPropostaDescricao === 'Pendente'){

        //   list.push({
        //     ...item,
        //     valorTotalFormatado: `R$ ${convertCurrency(item.valorTotal)}`,
        //   })
        // }
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.contractClientService
      .listPagedContractClient(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  // searchListItems() {
  //   this.loading = true
  //   this.contractClientService
  //     .searchPagedContractClient(this.page, this.rows, this.searchForm)
  //     .subscribe({
  //       next: (response: any) => {
  //         this.treatResponse(response)
  //       },
  //       error: (err: PagedContactTypeResponse) => { },
  //       complete: () => {
  //         this.loading = false
  //       },
  //     })
  // }

  newPriceQuote() {
    const dialogRef = this.dialog.open(ContractCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(ContractCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  cancelContract(item: any) {
    const dialogRef = this.dialog.open(ModalCancelContractComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '90vw',
      width: '100%',
      maxHeight: '90vh',
      data: { item: item },
    })
    dialogRef.componentInstance.responseDelete.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
    /*
    const dialogRef = this.dialog.open(DialogChooseComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: 'Deseja realmente cancelar o contrato? Todas as OS gerados a partir desse contrato serão cancelados.',
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.contractClientService.cancelContract(item.id).subscribe({
          next: (response: any) => {
            this.uploadList()
          },
          error: (err: PagedContactTypeResponse) => {},
          complete: () => {
            this.loading = false
          },
        })
      }
    })
    */
  }

  cancelProposal(proposalId: any) {
    //   this.proposalService.cancelProposal(proposalId).subscribe({
    //     next: (response: any) => {
    //       console.log('response: ', response)
    //       this.uploadList()
    //     },
    //     error: (err: PagedContactTypeResponse) => {},
    //     complete: () => {
    //       this.loading = false
    //     },
    //   })
  }

  // downloadItem(item: any) {
  //   this.contractClientService.downloadContractClient(item.id).subscribe({
  //     next: (response: any) => {
  //       console.log('res', response)
  //       downloadBase64File(
  //         response.data.fileContent,
  //         response.data.fileName,
  //         response.data.type,
  //       )
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => { },
  //   })
  // }

  deleteItem(item: any) {
    console.log('item delete', item)
  }
}
